var kCountdown = {
  $template: '#banner-countdown',
  $templateHtml: null,
  currentTimestamp: new Date(),
  interval: null,
  showBanner: function() {
      let that = this;
      if ($('.slide-banner-discount.onlymobile .k-countdown').length == 0) {
          $('.slide-banner-discount').each(function() {
              if ($(this).hasClass('onlymobile')) {
                  let tpl = `<p class="tw-mobile-discounts-countdown" onclick="window.open('${ k_countdown.link }');"><strong>${ k_countdown.text_mobile }</strong>
                  ${ that.$templateHtml }
                  <a class="tw-font-[500]" href="${ k_countdown.link }" target="_blank">${ k_countdown.btn_text }</a>
                  </p>`;
                  $(this).html(tpl);
              } else {
                let icon =$(this).find('svg');
                let tpl = `<p><strong>${ k_countdown.text }</strong>
                ${ that.$templateHtml }
                <a href="${ k_countdown.link }" target="_blank">${ k_countdown.btn_text }</a></p>`;
                $(this).html(tpl);
                if (icon.length) {
                    $(icon.first()).clone().prependTo(this);
                }
              }
          });
      }
  },
  isActive: function() {
      return k_countdown.enable && this.currentTimestamp >= k_countdown.start_date && this.currentTimestamp < k_countdown.end_date;
  },
  start: function() {
      // Update the count down every 1 second
      this.interval = setInterval(this.decrement, 1000);
      this.decrement();
  },
  decrement: function() {
      // Get today's date and time
      let now = new Date().getTime();

      // Find the distance between now and the count down date
      let distance = k_countdown.end_date.getTime() - now;

      // Time calculations for days, hours, minutes and seconds
      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hoursNormal = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let hoursReal = Math.floor((distance / 1000) / (60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);
      let hours = hoursNormal;

      let secondsHtml = $('.slide-banner-discount.onlymobile .k-countdown .k-countdown-seconds');
      if (hoursReal <= 38) { // 38 hours
          $('.k-countdown-days').addClass('tw-hidden');
          hours = hoursReal;
          secondsHtml.removeClass('tw-hidden');
      } else {
          secondsHtml.addClass('tw-hidden');
      }
      $('.k-countdown-days').html(`${ days }d`);
      $('.k-countdown-hours').html(`${ hours }h`);
      $('.k-countdown-minutes').html(`${ minutes }m`);
      $('.k-countdown-seconds').html(`${ seconds }s`);

      // If the count down is finished, write some text
      if (distance < 0) {
          clearInterval(kCountdown.interval);
          $('.k-countdown').addClass('tw-hidden');
      }
  },
  initBanner: function() {
      this.$templateHtml = $(this.$template).html();
      if (this.isActive()) {
          this.showBanner();
          this.start();
      }
  },
};
function urgencyPromo(expiredDate){
    if($('#promo-modal').length > 0){
        const second = 1000,
            minute = second * 60,
            hour = minute * 60,
            day = hour * 24;
        // expiredDate = "09//2024"
        const countDown = new Date(expiredDate).getTime(),
        x = setInterval(function() {    
            const now = new Date().getTime(),
                distance = countDown - now;
            if(distance > 0 ){
                $('.promo-body-timer .days').text(Math.floor(distance / (day)).toString().padStart(2, "0"));
                $('.promo-body-timer .hours').text(Math.floor((distance % (day)) / (hour)).toString().padStart(2, "0"));
                $('.promo-body-timer .minutes').text(Math.floor((distance % (hour)) / (minute)).toString().padStart(2, "0"));
                $('.promo-body-timer .seconds').text(Math.floor((distance % (minute)) / second).toString().padStart(2, "0"));
            }else{
                clearInterval(x);
                clearInterval(window.promoInterval);
                $('#promo-modal').addClass('tw-hidden');
            }
        }, 500)
    }
}